// Los toasts (Buefy Notification) renderizan `message` con v-html, y muchos
// mensajes traen texto del backend o de datos importados (nombres de
// contraparte, números de documento). Esto deja pasar sólo el formato que usan
// los mensajes y convierte todo lo demás en texto: un nombre como
// `<img src=x onerror=…>` se ve tal cual en vez de ejecutarse.

const ALLOWED_TAGS = new Set([
    "P", "BR", "STRONG", "B", "EM", "I", "SPAN", "UL", "OL", "LI",
]);
// Su contenido tampoco es texto para mostrar.
const DROPPED_TAGS = new Set([
    "SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "TEMPLATE", "NOSCRIPT",
]);
const ALLOWED_ATTRIBUTES = new Set(["class"]);

const ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

export function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (char) => ESCAPES[char]);
}

function cleanNode(node, doc) {
    Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
            return;
        }
        if (child.nodeType !== Node.ELEMENT_NODE) {
            child.remove();
            return;
        }
        if (DROPPED_TAGS.has(child.tagName)) {
            child.remove();
            return;
        }
        if (!ALLOWED_TAGS.has(child.tagName)) {
            // Etiqueta desconocida: se muestra como el texto que era.
            child.replaceWith(doc.createTextNode(child.outerHTML));
            return;
        }
        Array.from(child.attributes).forEach((attr) => {
            if (!ALLOWED_ATTRIBUTES.has(attr.name)) {
                child.removeAttribute(attr.name);
            }
        });
        cleanNode(child, doc);
    });
}

export function sanitizeHtml(html) {
    if (html === null || html === undefined) {
        return "";
    }
    // DOMParser no ejecuta scripts ni carga recursos al parsear.
    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
    cleanNode(doc.body, doc);
    return doc.body.innerHTML;
}
